export default __webpack_public_path__ + "static/media/approve.61deaa60.svg";